import React from "react";
import { Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import DatePicker from "react-datepicker";

/**
 * Reusable date picker field component
 */
const DatePickerField = ({
  // Field props
  selected,
  onChange,
  placeholder,
  minDate,
  maxDate,

  // Validation props
  error,
  errorMessage,

  // Layout props
  colProps = {},
  className = "inputclass form-control",

  // Tooltip props
  tooltip,
  tooltipIcon,

  // DatePicker props
  showMonthDropdown = true,
  showYearDropdown = true,
  scrollableYearDropdown = true,
  shouldCloseOnSelect = true,

  // Ref and callbacks
  ref,
  onCalendarClose,

  // Other props
  ...otherProps
}) => {
  const renderTooltip = (props) => (
    <Tooltip id="date-tooltip" {...props}>
      {tooltip}
    </Tooltip>
  );

  return (
    <Col {...colProps} className={tooltip ? "position-relative" : ""}>
      {tooltip && tooltipIcon && (
        <span
          className="ques-info-icon"
          style={{ cursor: "pointer", float: "right" }}
        >
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
          >
            <img
              style={{
                width: "15px",
                bottom: "30px",
                position: "absolute",
                marginLeft: "4px",
              }}
              src={tooltipIcon}
              alt="Help"
            />
          </OverlayTrigger>
        </span>
      )}
      <div className="form-group">
        <DatePicker
          selected={selected}
          onChange={onChange}
          minDate={minDate}
          maxDate={maxDate}
          placeholderText={placeholder}
          className={className}
          showMonthDropdown={showMonthDropdown}
          showYearDropdown={showYearDropdown}
          scrollableYearDropdown={scrollableYearDropdown}
          shouldCloseOnSelect={shouldCloseOnSelect}
          onCalendarClose={onCalendarClose}
          ref={ref}
          {...otherProps}
        />
      </div>
      {error && <p style={{ color: "red" }}>{errorMessage}</p>}
    </Col>
  );
};

export default DatePickerField;
